import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMapPin,
  faMailBulk,
  faCodeCompare,
} from "@fortawesome/free-solid-svg-icons";
export const Footer = () => {
  return (
    <div className="gpt3__footer ">
      <div className="gpt3__footer-heading" id="CTA">
        <h1>Click on the link below to get My CV</h1>
      </div>
      <div className="gpt3__footer-btn">
        <a href="https://app.resumecoach.com/share/2393e71fdec14561ad871305ac940082">
          <p>My CV</p>
        </a>
      </div>
      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <a href="#logo">
            <span>Eliya Gervas&trade;</span>
          </a>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Links</h4>
          <p>
            <a href="https://linkedin.com/in/eliyagervas27">LinkedIn</a>
          </p>
        </div>
        <div className="gpt3__footer-links_div" id="contacts">
          <h4>Get in Touch</h4>
          <div className="gpt3__footer-links_div-entry">
            <span>
              <FontAwesomeIcon icon={faMailBulk} />
            </span>
            <p>
              <a href="mailto:eliyagervas27@gmail.com">
                eliyagervas27@gmail.com
              </a>
            </p>
          </div>
          <div className="gpt3__footer-links_div-entry">
            <span>
              <FontAwesomeIcon icon={faCodeCompare} />
            </span>
            <p>
              <a href="https://github.com/eliya27">Github Account</a>
            </p>
          </div>
          <div className="gpt3__footer-links_div-entry">
            <span>
              <FontAwesomeIcon icon={faPhone} />
            </span>
            <p>
              <a href="https://wa.me/+255714344438">+255 714 344 438</a>
            </p>
          </div>
          <div className="gpt3__footer-links_div-entry">
            <span>
              <FontAwesomeIcon icon={faMapPin} />
            </span>
            <p>Temeke, Dar-es-salaam</p>
          </div>
        </div>
      </div>
      <div className="gpt3__footer-copyright">
        <p>2022 &copy; Eliya Gervas personal site</p>
      </div>
    </div>
  );
};
